/* BK_NAV_HOVER_v1 */
(() => {
  const dd = document.querySelectorAll(
    'header details.mega-menu, .header-wrapper details.mega-menu, .section-header details.mega-menu'
  );
  dd.forEach((d) => {
    let timer;
    d.addEventListener('mouseenter', () => {
      clearTimeout(timer);
      d.setAttribute('open', '');
    });
    d.addEventListener('mouseleave', () => {
      timer = setTimeout(() => d.removeAttribute('open'), 150);
    });
  });
})();
